import { SaleOrderMergeDataset } from '../../datasets';
import { FakeAccountContactMergeData, FakeAccountMergeData, FakeBasicSiteMergeData, FakeCompanyMergeData, FakeInvoiceAccountMergeData, FakeSaleOrderItemsMergeData, FakeSaleOrderMergeData } from '../data';

export class FakeSaleOrderMergeDataset extends SaleOrderMergeDataset {
    constructor(baseUrl: string = '') {
        super();

        this.saleOrder = new FakeSaleOrderMergeData();
        this.billingCompany = new FakeCompanyMergeData(baseUrl);
        this.customer = new FakeAccountMergeData();
        this.customerContact = new FakeAccountContactMergeData();
        this.saleOrderJobSite = new FakeBasicSiteMergeData();
        this.saleOrderItem = new FakeSaleOrderItemsMergeData();
    }
}

